export default __webpack_public_path__ + "static/media/ev-logo.cdc46740.svg";